import React from 'react';
import {deleteManualCalculateRow, updateManualCalculateRow} from "../../../../actions/sqftManualCalculationFunctions";
import {connect} from "react-redux";
import {MANUAL_CALCULATION_MEASURE, MANUAL_CALCULATION_ROW_TYPES} from "../../constants";
import sqftConfig from "../canvas/store/sqftConfig";

const SqftCountertopRow = (props) => {
  const {row, rowIndex, rowLetter, deleteManualCalculateRow, updateManualCalculateRow} = props;
  const handleDeleteClick = () => {
    deleteManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.countertopRows, row.id)
  };
  const handleUpdateClick = (event, measure) => {
    event.preventDefault();

    updateManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.countertopRows, row, {[measure]:event.target.value});
  };
  return (
    <div className="row body-row" data-index={rowIndex}>
      <div className="col-xs-2">
        {rowLetter}
      </div>
      <div className="col-xs-4">
        <input type="number"
               className="input-length"
               value={row.length} placeholder={sqftConfig.getMeasureUnitPostfix()}
               onChange={(e) => {handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.length)}}/>
      </div>
      <div className="col-xs-2">x</div>
      <div className="col-xs-4">
        <input type="number"
               className="input-width"
               value={row.width} placeholder={sqftConfig.getMeasureUnitPostfix()}
               onChange={(e) => {handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.width)}}/>
      </div>
      <div className="col-xs-2 circle" onClick={handleDeleteClick}>
        <span className="js-remove-row"/>
      </div>
    </div>
  )
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
  updateManualCalculateRow,
  deleteManualCalculateRow
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftCountertopRow);
